import './style.sass';

import clsx from 'clsx';
import React from 'react';

const DescriptionCaseMinor = ({ item, customChildrenClass }) => {
    return (
        <div className={clsx('description-case-minor', customChildrenClass)}>
            <div
                dangerouslySetInnerHTML={{ __html: item.description }}
                className="description-case-minor__description"
            />
            {item.imgName && item.icon && (
                <div className="description-case-minor__item-wrapper">
                    <div className="description-case-minor__item-block">
                        <img
                            alt={item.imgName}
                            className="description-case-minor__item-icon"
                            src={item.icon}
                        />
                        <div className="description-case-minor__item-name">{item.imgName}</div>
                    </div>
                </div>
            )}
            {item.subtitle && (
                <div className="description-case-minor__item">
                    <div className="description-case-minor__subtitle">{item.subtitle}</div>
                    <img
                        className="description-case-minor__image"
                        src={item.img}
                        alt={item.subtitle}
                    />
                </div>
            )}
        </div>
    );
};
export default DescriptionCaseMinor;
